import React from 'react';
import { PictoProps } from './index';

export const Minus = (props: PictoProps) => (
  <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.6667 0.999837H1.33333"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
